import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
  NavItem,
  NavLink
} from "shards-react";

const UserActions = ({ location, clickUseraction, useraction }) => {
  const localId = window.sessionStorage.getItem('userid');
  return (
    <NavItem tag={Dropdown} caret toggle={clickUseraction}>
      <DropdownToggle caret tag={NavLink} className="text-nowrap px-3" style={{ cursor: "pointer" }}>
        <img
          className="user-avatar rounded-circle mr-2"
          src={require("./../../../../images/avatars/user (1).png")}
          alt="User Avatar"
        />{" "}
        <span className="d-none d-md-inline-block">{localId}</span>
      </DropdownToggle>
      <Collapse tag={DropdownMenu} right small open={useraction}>
        <DropdownItem tag={Link} to="/" className="text-danger" onClick={() => {
          if (window.confirm("로그아웃 하시겠습니까?")) {

            window.sessionStorage.clear();
            location.reload();
          }
        }}>
          <i className="material-icons text-danger">&#xE879;</i> Logout
        </DropdownItem>
      </Collapse>
    </NavItem>
  );
}

export default UserActions;